/* eslint-disable react/no-danger */
import * as React from 'react';

import PropTypes from 'prop-types';

import { prependUrlProtocolIfNone } from 'bundles/common/utils/urlUtils';
import { websitesInfo } from 'bundles/partners-graphql/constants';
import { clearEmptyFields } from 'bundles/seo/utils/utils';

class InstructorProfileGoogleSchemaMarkup extends React.Component {
  static propTypes = {
    instructor: PropTypes.object,
    description: PropTypes.string,
    pathname: PropTypes.string,
  };

  constructInstructorExternalLinks = () => {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'instructor' does not exist on type 'Read... Remove this comment to see the full error message
      instructor: { websites },
    } = this.props;
    const externalLinks = Object.keys(websites);
    const instructorExternalLinks = {};

    externalLinks.forEach((link) => {
      const externalLinkInfo = websites[link] && websitesInfo[link];
      if (externalLinkInfo) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        instructorExternalLinks[link] = prependUrlProtocolIfNone(`${externalLinkInfo.prefix}${websites[link]}`);
      }
    });

    return instructorExternalLinks;
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'instructor' does not exist on type 'Read... Remove this comment to see the full error message
    const { instructor, description, pathname } = this.props;

    const markupJson = {
      '@context': 'http://schema.org',
      '@type': 'WebPage',
      Name: `${instructor.fullName}, Instructor | Coursera`,
      url: `https://www.coursera.org${pathname}`,
      about: {
        '@id': `https://www.coursera.org${pathname}#instructor`,
        '@type': 'Person',
        name: `${instructor.fullName}`,
        description,
        image: `${instructor.photo}`,
        url: instructor.partners.elements.map((partner: $TSFixMe) => partner.links.website),
        sameAs: Object.values(this.constructInstructorExternalLinks()),
      },
      mainEntity: {
        '@type': 'ItemList',
        itemListElement: instructor.courses.elements.map((course: $TSFixMe, i: $TSFixMe) => ({
          '@type': 'ListItem',
          position: i + 1,
          '@id': `https://www.coursera.org/learn/${course.slug}#mooc`,
          url: `https://www.coursera.org/learn/${course.slug}`,
        })),
      },
    };

    const createMarkup = () => ({
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(clearEmptyFields(markupJson))}
        </script>
      `,
    });

    return (
      <div className="rc-InstructorProfileGoogleSchemaMarkup">
        <div dangerouslySetInnerHTML={createMarkup()} />
      </div>
    );
  }
}

export default InstructorProfileGoogleSchemaMarkup;
